import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";

import { connect } from 'react-redux';

import Button from "components/CustomButton/CustomButton.jsx";

import { makeAccountPayment, markSaleOrderInProgress } from 'reducers/payment/paymentActions';

import { updateGeneralUpdateQuotasToPay } from 'reducers/quotastopay/quotastopayActions';

import { updateSaleOrderAtPaymentPlan } from 'reducers/paymentplan/paymentplanActions';

import history from 'utils/History/history';

import PaymentDetail from './PaymentDetail';

import { withRouter } from 'react-router'

import { getObject } from 'utils/Storage/StorageUtils';

import { PAYMENT_DETAIL_STORAGE } from 'constants/storageConst';

import {
  SALEORDER_STATUS_DRAFT,
  SALEORDER_STATUS_PRODUCT_RESERVED,
  SALEORDER_STATUS_CONFIRMED,
  SALEORDER_STATUS_SIGNED_CONTRACT
} from 'constants/saleOrderStatusConst';

import jwt_decode from 'jwt-decode';

class SuccessfulPaymentStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      messageClass: "",
      token: null
    };
  }

  componentWillMount() {
    const queryParams = this.props.location.search;
    const params = new URLSearchParams(queryParams.replace("?", ""));

    const success = params.get('success');
    if (success != null && success !== "") {
      this.setState({
        message: "Su pago ha sido enviado correctamente. En unos minutos recibirá un correo de confirmación del mismo.",
        messageClass: "text-info"
      });
    } else {
      this.setState({
        message: "Pago realizado satisfactoriamente.",
        messageClass: "text-success"
      });
    }

    const token = params.get('token');
    if (token != null && token !== "") {
      const paymentDetail = getObject(PAYMENT_DETAIL_STORAGE);
      this.props.updateGeneralUpdateQuotasToPay(paymentDetail);
      this.props.markSaleOrderInProgress(token);
    }

  }

  isValidated() {
    return false;
  }

  goToPaymentPlan() {
    let saleOrder = this.props.quotasToPay.saleOrder;
    this.props.updateSaleOrderAtPaymentPlan(saleOrder);
    history.push("paymentplan");
  }

  goMyPayments() {
    history.push("mypayments");
  }

  render() {
    let redirectButton;

    if (this.props.quotasToPay.saleOrder.status === SALEORDER_STATUS_SIGNED_CONTRACT) {
      redirectButton = <div className="wizard-finish-button">
        <Button
          bsStyle="info"
          fill
          wd
          onClick={() => this.goToPaymentPlan()}
          pullRight
        >
          Ir a Plan de Pagos
    </Button>
      </div>
    } else {
      redirectButton = <div className="wizard-finish-button">
        <Button
          bsStyle="info"
          fill
          wd
          onClick={() => this.goMyPayments()}
          pullRight
        >
          Ir a Mis Pagos
    </Button>
      </div>
    }

    return (
      <div className="wizard-step">
        <Row>
          <Col md={10} mdOffset={1}>
            <div className={this.state.messageClass + " text-center"}>
              <h1>{this.state.message}</h1>
            </div>
            <Col md={8} mdOffset={2}>
              <PaymentDetail successPayment={true} />
            </Col>
          </Col>
        </Row>
        {redirectButton}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  quotasToPay: state.quotasToPay,
  accountInfo: state.account.info
});

export default connect(
  mapStateToProps,
  { makeAccountPayment, updateSaleOrderAtPaymentPlan, updateGeneralUpdateQuotasToPay, markSaleOrderInProgress }
)(withRouter(SuccessfulPaymentStep));



// WEBPACK FOOTER //
// ./src/components/PaymentWizard/SuccessfulPaymentStep.jsx